import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./DateTimeDisplay.module.scss"
import { usePolyglot } from "src/contexts"
import {
  useDisplayTime,
  useDisplayDate,
} from "src/hooks"
import type { ReadOnlyUserEvent } from "src/types"

const polyglotPrefix = "components.entry_modal."

interface Props {
  userEvent: ReadOnlyUserEvent;
}

export function DateTimeDisplay(props: Props) {
  const { userEvent } = props

  const polyglot = usePolyglot()

  const displayDate = useDisplayDate()
  const displayTime = useDisplayTime()

  const datetime =
    userEvent.event_type !== ActivityType.Bolus &&
     userEvent.event_type !== ActivityType.PumpSuspension ?
      polyglot.t(
        `${polyglotPrefix}datetime.summary`,
        {
          date: displayDate(userEvent.started_at ?? ""),
          time: displayTime(userEvent.started_at ?? ""),
        },
      ) : displayDate(userEvent.started_at ?? "")

  return (
    <div className={`${styles.datetime} ${styles.readonly}`}>
      {datetime}
    </div>
  )
}
